export function applyInstitutionFilter(query, isAdmin, instituicaoId) {
  try {
    // Super admin (papel admin) ou usuário admin sem instituição restrita tem acesso total
    if (isAdmin) {
      return query
    }
    // Usuários regulares devem ser filtrados por instituição
    if (instituicaoId) {
      return query.eq("instituicao_id", instituicaoId)
    }
  } catch (e) {
    // if query is not chainable, just return it
  }
  return query
}

export function ensureInstitutionOnPayload(payload, isAdmin, instituicaoId) {
  // For regular users, enforce tenant ID. For admin, keep provided value or null.
  if (instituicaoId) {
    return { ...payload, instituicao_id: instituicaoId }
  }

  // If payload already has instituicao_id, preserve it (useful for admin edit flow)
  if (payload && payload.instituicao_id) {
    return payload
  }

  return payload
}
